import {
  SHOW_LOADER,
  SHOW_SUCCESS_MESSAGE,
  SHOW_ERROR_MESSAGE,
} from "./actionTypes";

const initialState = {
  commonLoader: false,
  commonSuccessMessage: null,
  commonErrorMessage: null,
};

const showLoaderReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_LOADER:
      state = {
        ...state,
        commonLoader: true,
        commonSuccessMessage: null,
        commonErrorMessage: null,
      };
      break;
    case SHOW_SUCCESS_MESSAGE:
      state = {
        ...state,
        commonLoader: false,
        commonSuccessMessage: action.payload,
        commonErrorMessage: null,
      };
      break;
    case SHOW_ERROR_MESSAGE:
      state = {
        ...state,
        commonLoader: false,
        commonSuccessMessage: null,
        commonErrorMessage: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default showLoaderReducer;
